export const instanceConfigs = {
  moscow: {
    city: "moscow",
    timeZone: "+3",
    layout: {},
    map: {
      center: { lat: 55.68, lng: 37.63 },
      maxBounds: null,
      zoom: 10
    }
  },
  // TODO: Chelyabinsk
  chelyabinsk: {
    city: "chelyabinsk",
    timeZone: "+5",
    model: {
      id: "8a87207b-c0a4-43ac-97fd-a9b83db5f961"
    },
    hasMatrix: true,
    map: {
      center: { lat: 55.12, lng: 61.43 },
      maxBounds: [[60, 54.4], [63, 56]],
      zoom: 11
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_traffic_light_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_traffic_light_count" },
            chartRequest: {
              url: "chsmeo_traffic_light?format=history"
            },
            hasChart: true
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_pdk_cams_count?format=from_service",
            type: "type-1",
            request: {
              type: "statistic",
              url: "chsmeo_pdk_cams_count?format=from_service"
            }
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_cams_kps?format=count_from_service",
            type: "type-1",
            request: {
              type: "statistic",
              url: "chsmeo_cams_kps?format=count_from_service"
            },
            chartRequest: {
              url: "chsmeo_cams_kps?format=history"
            },
            hasChart: true
          }
        },
        // {
        //   name: "status-widget",
        //   props: {
        //     layer_id: "chsmeo_cams?format=stat",
        //     type: "type-3",
        //     request: { type: "statistic", url: "chsmeo_cams?format=stat" },
        //     chartRequest: {
        //       url: "chsmeo_cams?format=history"
        //     },
        //     hasChart: true
        //   }
        // },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_meteo_data_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_meteo_data_count" }
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_wialon_tracks?format=stat",
            request: {
              type: "statistic",
              url: "chsmeo_wialon_tracks?format=stat"
            },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_wialon_tracks?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_ngpt_count",
            request: { type: "statistic", url: "chsmeo_ngpt_count" },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_ngpt?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "category-widget",
          props: {
            event_layer: true,
            layer_id: "",
            request: {
              type: "",
              url: ""
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_tlt7_count",
            request: {
              type: "statistic",
              url: "chsmeo_tlt7_count"
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        }
      ]
    },
    mapLayers: [
      {
        layer_id: "chsmeo_traffic_light",
        has_image: true,
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_traffic_light" }
      },
      {
        layer_id: "chsmeo_tlt7",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_tlt7" }
      },
      {
        layer_id: "chsmeo_cams",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_cams" }
      },
      {
        layer_id: "chsmeo_cams_kps",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_cams_kps" }
      },
      {
        layer_id: "chsmeo_meteo_data?format=from_service",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "chsmeo_meteo_data?format=from_service"
        }
      },
      {
        track_url: "2f7a1431-10fb-403e-a929-764e136979ac",
        layer_id: "chsmeo_ngpt",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_ngpt" }
      },
      {
        layer_id: "chsmeo_wialon_tracks",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_wialon_tracks" }
      },
      {
        layer_id: "7fc1a76e-84e7-44b7-aed0-b3df8b04b867",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "7fc1a76e-84e7-44b7-aed0-b3df8b04b867"
        }
      },
      {
        event_layer: true,
        events: true,
        type: "default",
        layer_id: "",
        request: {
          type: "",
          url: ""
        }
      },
      {
        layer_id: "http://192.168.88.69:10262/api/ritm",
        type: "default",
        events: true,
        request: {
          type: "events-2",
          url: "http://192.168.88.69:10262/api/ritm"
        }
      }
    ],
    mapTileLayers: [
      {
        id: "podd",
        url: "chsmeo_podd?format=from_service"
      },
      {
        id: "podd-dornadzor-layer",
        source: {
          type: "raster",
          tiles: [
            `https://gis.dornadzor-sz.ru/drn/rest/services/odd/PODD_RITM3_2/MapServer/export?bbox={bbox-epsg-3857}&layers=&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      },
      {
        id: "podd-dorconsulting-layer",
        source: {
          type: "raster",
          tiles: [
            `http://ext-tiles.roadcons.ru/data/chelyabinsk_podd_test/{z}/{x}/{y}.png`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      }
    ]
  },
  // TODO: prod & dev
  hamster: {
    city: "chelyabinsk",
    timeZone: "+5",
    model: {
      id: "4f2a0a86-2ab0-4e22-bee0-7e5be31eb771"
    },
    hasMatrix: true,
    map: {
      center: { lat: 55.12, lng: 61.43 },
      maxBounds: null,
      zoom: 11
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_traffic_light_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_traffic_light_count" },
            chartRequest: {
              url: "chsmeo_traffic_light?format=history"
            },
            hasChart: true
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_pdk_cams_count?format=from_service",
            type: "type-1",
            request: {
              type: "statistic",
              url: "chsmeo_pdk_cams_count?format=from_service"
            }
          }
        },
        // {
        //   name: "status-widget",
        //   props: {
        //     layer_id: "chsmeo_cams?format=stat",
        //     type: "type-3",
        //     request: { type: "statistic", url: "chsmeo_cams?format=stat" },
        //     chartRequest: {
        //       url: "chsmeo_cams?format=history"
        //     },
        //     hasChart: true
        //   }
        // },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_meteo_data_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_meteo_data_count" }
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_wialon_tracks?format=stat",
            request: {
              type: "statistic",
              url: "chsmeo_wialon_tracks?format=stat"
            },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_wialon_tracks?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_ngpt_count",
            request: { type: "statistic", url: "chsmeo_ngpt_count" },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_ngpt?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "events-log",
          props: {
            event_layer: true,
            layer_id: "",
            request: {
              type: "",
              url: ""
            },
            type: "type-1"
          }
        }
      ]
    },
    mapLayers: [
      {
        layer_id: "chsmeo_traffic_light",
        has_image: true,
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_traffic_light" }
      },
      {
        layer_id: "chsmeo_tlt7",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_tlt7" }
      },
      {
        layer_id: "chsmeo_cams",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_cams" }
      },
      {
        layer_id: "chsmeo_meteo_data?format=from_service",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "chsmeo_meteo_data?format=from_service"
        }
      },
      {
        track_url: "2f7a1431-10fb-403e-a929-764e136979ac",
        layer_id: "chsmeo_ngpt",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_ngpt" }
      },
      {
        layer_id: "chsmeo_wialon_tracks",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_wialon_tracks" }
      },
      {
        layer_id: "12ff4f13-bb98-43c8-bd34-d69808b72c5d",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "12ff4f13-bb98-43c8-bd34-d69808b72c5d"
        }
      },
      {
        event_layer: true,
        events: true,
        type: "default",
        layer_id: "",
        request: {
          type: "",
          url: ""
        }
      }
    ],
    mapTileLayers: [
      {
        id: "podd-dornadzor-layer",
        source: {
          type: "raster",
          tiles: [
            `https://gis.dornadzor-sz.ru/drn/rest/services/odd/PODD_RITM3_2/MapServer/export?bbox={bbox-epsg-3857}&layers=&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      },
      {
        id: "podd-dorconsulting-layer",
        source: {
          type: "raster",
          tiles: [
            `http://ext-tiles.roadcons.ru/data/chelyabinsk_podd_test/{z}/{x}/{y}.png`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      }
    ]
  },
  ritm: {
    city: "chelyabinsk",
    timeZone: "+5",
    model: {
      id: "4f2a0a86-2ab0-4e22-bee0-7e5be31eb771"
    },
    hasMatrix: true,
    map: {
      center: { lat: 55.12, lng: 61.43 },
      maxBounds: null,
      zoom: 11
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_traffic_light_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_traffic_light_count" },
            chartRequest: {
              url: "chsmeo_traffic_light?format=history"
            },
            hasChart: true
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_pdk_cams_count?format=from_service",
            type: "type-1",
            request: {
              type: "statistic",
              url: "chsmeo_pdk_cams_count?format=from_service"
            }
          }
        },
        // {
        //   name: "status-widget",
        //   props: {
        //     layer_id: "chsmeo_cams?format=stat",
        //     type: "type-3",
        //     request: { type: "statistic", url: "chsmeo_cams?format=stat" },
        //     chartRequest: {
        //       url: "chsmeo_cams?format=history"
        //     },
        //     hasChart: true
        //   }
        // },
        {
          name: "status-widget",
          props: {
            layer_id: "chsmeo_meteo_data_count",
            type: "type-1",
            request: { type: "statistic", url: "chsmeo_meteo_data_count" }
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_wialon_tracks?format=stat",
            request: {
              type: "statistic",
              url: "chsmeo_wialon_tracks?format=stat"
            },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_wialon_tracks?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "chsmeo_ngpt_count",
            request: { type: "statistic", url: "chsmeo_ngpt_count" },
            type: "default",
            size: "small",
            chartRequest: {
              url: "chsmeo_ngpt?format=history"
            },
            hasChart: true,
            hasModal: true
          }
        },
        {
          name: "events-log",
          props: {
            event_layer: true,
            layer_id: "",
            request: {
              type: "",
              url: ""
            },
            type: "type-1"
          }
        }
      ]
    },
    mapLayers: [
      {
        layer_id: "chsmeo_traffic_light",
        has_image: true,
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_traffic_light" }
      },
      {
        layer_id: "chsmeo_tlt7",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_tlt7" }
      },
      {
        layer_id: "chsmeo_cams",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_cams" }
      },
      {
        layer_id: "chsmeo_meteo_data?format=from_service",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "chsmeo_meteo_data?format=from_service"
        }
      },
      {
        track_url: "2f7a1431-10fb-403e-a929-764e136979ac",
        layer_id: "chsmeo_ngpt",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_ngpt" }
      },
      {
        layer_id: "chsmeo_wialon_tracks",
        type: "default",
        events: true,
        request: { type: "features", url: "chsmeo_wialon_tracks" }
      },
      {
        layer_id: "12ff4f13-bb98-43c8-bd34-d69808b72c5d",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "12ff4f13-bb98-43c8-bd34-d69808b72c5d"
        }
      },
      {
        event_layer: true,
        events: true,
        type: "default",
        layer_id: "",
        request: {
          type: "",
          url: ""
        }
      }
    ],
    mapTileLayers: [
      {
        id: "podd-dornadzor-layer",
        source: {
          type: "raster",
          tiles: [
            `https://gis.dornadzor-sz.ru/drn/rest/services/odd/PODD_RITM3_2/MapServer/export?bbox={bbox-epsg-3857}&layers=&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&f=image`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      },
      {
        id: "podd-dorconsulting-layer",
        source: {
          type: "raster",
          tiles: [
            `http://ext-tiles.roadcons.ru/data/chelyabinsk_podd_test/{z}/{x}/{y}.png`
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 10,
        maxzoom: 21
      }
    ]
  },
  // TODO: TAGIIIIL
  tagil: {
    city: "nizhny tagil",
    timeZone: "+5",
    model: {
      id: "831e5617-9a7b-47d8-87c6-682f71589696"
    },
    map: {
      center: { lat: 57.9, lng: 59.98 },
      maxBounds: null,
      zoom: 11
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "status-widget",
          props: {
            layer_id: "tagil_traffic_light_count",
            type: "type-1",
            request: { type: "statistic", url: "tagil_traffic_light_count" }
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "TagilDetector?format=stats",
            type: "type-1",
            request: { type: "statistic", url: "TagilDetector?format=stats" },
            hasChart: true
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id: "TagilPublicTransport?format=dit_stats",
            type: "type-1",
            request: {
              type: "statistic",
              url: "TagilPublicTransport?format=dit_stats"
            },
            hasChart: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "TagilPublicTransport?format=vehicles_stats",
            request: {
              type: "statistic",
              url: "TagilPublicTransport?format=vehicles_stats"
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "TagilPublicTransport?format=stops_stats",
            request: {
              type: "statistic",
              url: "TagilPublicTransport?format=stops_stats"
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        },
        {
          name: "category-widget",
          props: {
            layer_id: "TagilPublicTransport?format=routes_stats",
            request: {
              type: "statistic",
              url: "TagilPublicTransport?format=routes_stats"
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        },
        {
          name: "category-widget",
          props: {
            event_layer: true,
            layer_id: "",
            request: {
              type: "",
              url: ""
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        }
      ]
    },
    mapLayers: [
      {
        layer_id: "TagilDetector",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "TagilDetector"
        },
        cardChart: {
          url: "TagilDetector?format=intensity",
          type: "speed-intensity"
        }
      },
      {
        track_url: "TagilPublicTransport?format=track_data",
        layer_id: "TagilPublicTransport?format=vehicles",
        type: "filterable",
        events: true,
        request: {
          type: "features",
          url: "TagilPublicTransport?format=vehicles",
          mapping: "telemetry"
        }
      },
      {
        layer_id: "tagil_traffic_light?format=from_service",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "tagil_traffic_light?format=from_service"
        }
      },
      {
        layer_id: "TagilPublicTransport?format=stops",
        type: "default",
        events: true,
        requestToInfo: true,
        request: {
          type: "features",
          url: "TagilPublicTransport?format=stops"
        }
      },
      {
        layer_id: "TagilPublicTransport?format=dit",
        type: "default",
        events: true,
        requestToInfo: true,
        request: {
          type: "features",
          url: "TagilPublicTransport?format=dit"
        }
      },
      {
        layer_id: "8560fe75-49b2-432a-8494-eab530c8fc4e",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "8560fe75-49b2-432a-8494-eab530c8fc4e"
        }
      },
      {
        event_layer: true,
        events: true,
        type: "default",
        layer_id: "",
        request: {
          type: "",
          url: ""
        }
      }
    ]
  },
  // TODO: TOOOOMSK
  tomsk: {
    city: "tomsk",
    timeZone: "+7",
    model: {
      id: "50833943-87c3-4104-a155-e8ed855445ac"
    },
    map: {
      center: { lat: 56.484, lng: 84.947 },
      maxBounds: [[83, 55.5], [86.9, 57.5]],
      zoom: 11
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "category-widget",
          props: {
            event_layer: true,
            layer_id: "",
            request: {
              type: "",
              url: ""
            },
            type: "default",
            size: "small",
            hasChart: true
          }
        }
      ]
    },
    mapLayers: [
      {
        track_url: "telemetry.track_data",
        layer_id: "track/telemetry.track_data?format=last_tracks",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "track/telemetry.track_data?format=last_tracks",
          mapping: "telemetry"
        }
      },
      {
        event_layer: true,
        events: true,
        type: "default",
        layer_id: "",
        request: {
          type: "",
          url: ""
        }
      }
    ]
  },
  // TODO: LenObl
  lenoblast: {
    city: "saint petersburg",
    timeZone: "+3",
    model: {
      id: "6d8cc463-bff6-4f00-a40b-796324cb5308"
    },
    map: {
      center: { lat: 59.917, lng: 30.344 },
      maxBounds: null,
      zoom: 8
    },
    layout: {
      config: {
        bottom_block: {
          position: "center"
        }
      },
      layer_controller: true,
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }],
      bottom_block: [
        {
          name: "status-widget",
          props: {
            layer_id: "count/2600d74b-3842-4311-9aa7-a2d742df36da?field=online",
            type: "type-1",
            request: {
              type: "statistic",
              url: "count/2600d74b-3842-4311-9aa7-a2d742df36da?field=online"
            }
          }
        },
        {
          name: "status-widget",
          props: {
            layer_id:
              "count/875c93e3-dc09-41bc-b675-51b7461abca1?field=error_flags",
            type: "type-1",
            request: {
              type: "statistic",
              url:
                "count/875c93e3-dc09-41bc-b675-51b7461abca1?field=error_flags"
            }
          }
        }
        // {
        //   name: "category-widget",
        //   props: {
        //     event_layer: true,
        //     layer_id: "",
        //     request: {
        //       type: "",
        //       url: ""
        //     },
        //     type: "default",
        //     size: "small",
        //     hasChart: true
        //   }
        // }
      ]
    },
    mapLayers: [
      {
        layer_id: "2600d74b-3842-4311-9aa7-a2d742df36da",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "2600d74b-3842-4311-9aa7-a2d742df36da"
        }
      },
      {
        layer_id: "875c93e3-dc09-41bc-b675-51b7461abca1",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "875c93e3-dc09-41bc-b675-51b7461abca1"
        }
      },
      {
        layer_id: "fe19e836-9559-4834-9f3d-722001dd3dbf",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "fe19e836-9559-4834-9f3d-722001dd3dbf"
        }
      },
      {
        layer_id: "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3",
        type: "default",
        events: true,
        request: {
          type: "objectInfo",
          url: "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3"
        }
      },
      {
        layer_id: "https://lenobl.ritm3.ru/xml_server_results/?limit=10",
        type: "default",
        events: true,
        request: {
          type: "hard",
          url: "https://lenobl.ritm3.ru/xml_server_results/?limit=10",
          geom: {
            type: "Point",
            coordinates: [30.007456, 60.023012]
          }
        }
      },
      {
        track_url: "telemetry.track_data",
        layer_id: "track/telemetry.track_data?format=last_tracks",
        type: "default",
        events: true,
        request: {
          type: "features",
          url: "track/telemetry.track_data?format=last_tracks",
          mapping: "telemetry"
        }
      }
      // {
      //   event_layer: true,
      //   events: true,
      //   type: "default",
      //   layer_id: "",
      //   request: {
      //     type: "",
      //     url: ""
      //   }
      // }
    ],
    mapTileLayers: [
      {
        id: "traffic_flow_tomtom",
        source: {
          type: "raster",
          tiles: [
            "https://api.tomtom.com/traffic/map/4/tile/flow/relative0/{z}/{x}/{y}.png?t=-1&key=31hU2eUjAapxwJjCAZ5A4egzGfaVvLuL"
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 8,
        maxzoom: 21
      },
      {
        id: "traffic_incidents_tomtom",
        source: {
          type: "raster",
          tiles: [
            "https://api.tomtom.com/traffic/map/4/tile/incidents/s0/{z}/{x}/{y}.png?t=-1&key=31hU2eUjAapxwJjCAZ5A4egzGfaVvLuL"
          ],
          tileSize: 256
        },
        type: "raster",
        minzoom: 8,
        maxzoom: 21
      },
      {
        id: "podd",
        source: {
          type: "raster",
          tiles: [
            "https://gis.dornadzor-sz.ru/drn/rest/services/odd/RITMPR/MapServer/export?bbox={bbox-epsg-3857}&format=png&transparent=true&f=image"
          ],
          tileSize: 256
        },
        type: "raster"
      }
    ]
  },
  default: {
    city: "moscow",
    timeZone: "+3",
    layout: {
      left_block: [{ name: "title-bar-widget", props: { type: "default" } }]
    },
    map: {
      center: { lat: 55.68, lng: 37.63 },
      maxBounds: null,
      zoom: 10
    }
  }
};
